import { defineMessages } from 'react-intl';

export default defineMessages({
  cardLabel: {
    id: 'frontbucket.repository.source.sidebar.fileDetailsCard.label',
    description: 'Header for the file details sidebar card',
    defaultMessage: 'File details',
  },
  lastUpdatedLabel: {
    id: 'frontbucket.repository.source.file.details.lastUpdatedLabel',
    description:
      'Label for the date representing the last time a file was updated',
    defaultMessage: 'Last updated',
  },
  lineCountLabel: {
    id: 'frontbucket.repository.source.file.details.lineCountLabel',
    description: 'Label for the number of lines a file contains',
    defaultMessage: 'Lines',
  },
  sizeLabel: {
    id: 'frontbucket.repository.source.file.details.sizeLabel',
    description: 'Label for the size of the file',
    defaultMessage: 'Size',
  },
  typeLabel: {
    id: 'frontbucket.repository.source.file.details.typeLabel',
    description: 'Label for the file type',
    defaultMessage: 'File type',
  },
});
